import GameObject from '../../GameObject/GameObject';
import { ConcatIterators, PlayAnimation, StopAnimation } from '../../System/Animation/AnimationHelper';
import Armature from 'Prototype/Armature';
import { DragonbonesFadeIn } from 'System/Animation/Clip';

export class PlinkoLoadingScreen extends GameObject {
    public plinkoArmature: Armature;
    public iconArmature: Armature;

    protected onCreate(params: any): void {
        this.plinkoArmature = GameObject.Instantiate(Armature, {
            name: 'plinkoArmature',
            dragonbonesName: 'plinko_game_transition',
            armatureName: 'Armature',
            animationName: 'animation',
            playOnStart: false,
            alpha: 0,
        });
        this.addChild(this.plinkoArmature);
    }

    public *animate(): IterableIterator<number> {
        yield* ConcatIterators([
            PlayAnimation(
                new DragonbonesFadeIn(this.plinkoArmature, {
                    playTimes: 1,
                    fadeInTime: 200,
                    animationName: 'animation',
                    concat: false,
                })
            ),
        ])
    }

    public stopAnimation() {
        StopAnimation(this.plinkoArmature);
    }
}
